/* Dark mode toggle with localStorage persistence */
(function () {
    const STORAGE_KEY = 'chaparii-dark-mode';
    const html = document.documentElement;
    
    // Get stored preference or system preference
    function getPreference() {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored !== null) {
            return stored === 'true';
        }
        // Fall back to system preference
        return window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    
    // Apply dark mode class
    function applyDarkMode(isDark) {
        // Remove text contrast classes when switching modes
        html.classList.remove('has-dark-text', 'has-light-text');
        
        if (isDark) {
            html.classList.add('dark-mode');
        } else {
            html.classList.remove('dark-mode');
            // Recalculate text contrast for light mode
            recalculateTextContrast();
        }
    }
    
    // Recalculate text contrast based on background color
    function recalculateTextContrast() {
        var style = getComputedStyle(document.documentElement);
        var bgColor = style.getPropertyValue('--background-color').trim();
        if (!bgColor || bgColor.charAt(0) !== '#') return;
        
        var accentColor = bgColor.slice(1);
        if (accentColor.length === 3) {
            accentColor = accentColor[0] + accentColor[0] + accentColor[1] + accentColor[1] + accentColor[2] + accentColor[2];
        }
        var r = parseInt(accentColor.substr(0, 2), 16);
        var g = parseInt(accentColor.substr(2, 2), 16);
        var b = parseInt(accentColor.substr(4, 2), 16);
        var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        var textColor = (yiq >= 128) ? 'dark' : 'light';
        html.classList.add('has-' + textColor + '-text');
    }
    
    // Sync dark mode state with localStorage (for bfcache/back button)
    function syncDarkModeState() {
        const shouldBeDark = getPreference();
        const isDark = html.classList.contains('dark-mode');
        if (shouldBeDark !== isDark) {
            applyDarkMode(shouldBeDark);
        }
    }
    
    // Toggle dark mode
    function toggleDarkMode() {
        const isDark = html.classList.contains('dark-mode');
        const newMode = !isDark;
        localStorage.setItem(STORAGE_KEY, String(newMode));
        applyDarkMode(newMode);
    }
    
    // Initialize toggle buttons
    function initToggleButtons() {
        const toggleButtons = document.querySelectorAll('.gh-darkmode-toggle');
        toggleButtons.forEach(function (button) {
            button.addEventListener('click', toggleDarkMode);
        });
    }
    
    // Listen for system preference changes
    function listenForSystemChanges() {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        mediaQuery.addEventListener('change', function (e) {
            // Only update if user hasn't set a manual preference
            if (localStorage.getItem(STORAGE_KEY) === null) {
                applyDarkMode(e.matches);
            }
        });
    }
    
    // Handle page show event (fires when page is restored from bfcache)
    window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            // Page was restored from bfcache, sync dark mode state
            syncDarkModeState();
        }
    });
    
    // Also check on visibility change (for some mobile browsers)
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
            syncDarkModeState();
        }
    });
    
    // Initialize on DOM ready
    initToggleButtons();
    listenForSystemChanges();
    
    // Initial sync in case page loaded from cache
    syncDarkModeState();
})();
